import React from "react";
import styles from "./FeeRemainderEmail.module.css";
import Action from "../../components/Action/Action";
import { FiClock } from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";

const FeeRemainderEmail = ({
  message,
  subject,
  to,
  time,
  date,
  sendIn,
  onRemoveRecipient,
  onActionSelect,
  id,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.title}>Email</span>
        <Action
          options={["Edit", "Delete"]}
          onSelect={(opt) => onActionSelect(opt, id)}
        />
      </div>

      <div className={styles.separator}>
        <div className={styles.section}>
          <label>Email</label>
          <div className={`${styles.textBox} ${styles.utilityBackground}`}>
            {message}
          </div>
        </div>

        <div className={styles.section}>
          <label>Subject</label>
          <input
            className={`${styles.input} ${styles.utilityBackground}`}
            value={subject}
            readOnly
          />
        </div>

        <div className={styles.section}>
          <label>To</label>
          <div className={styles.recipientBox}>
            <div className={styles.toWrapper}>
              {to.map((email, i) => (
                <span key={i} className={styles.recipient}>
                  {email}
                  <IoCloseOutline
                    size={16}
                    onClick={() => onRemoveRecipient(id, email)}
                    className={styles.removeIcon}
                  />
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className={styles.footer}>
          <span>Email will be sent in {sendIn}</span>
          <span className={styles.time}>
            <FiClock size={14} /> {time} &nbsp; • &nbsp; {date}
          </span>
        </div>
      </div>
    </div>
  );
};

export default FeeRemainderEmail;
